import './GetAlertsButton.css';

function BellIconSmall() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" aria-hidden="true">
      <path
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"
      />
      <path
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M13.73 21a2 2 0 0 1-3.46 0"
      />
    </svg>
  );
}

/**
 * @param {{
 *   onClick: () => void;
 *   variant?: 'toolbar' | 'text';
 *   className?: string;
 *   label?: string;
 * }} props
 */
export function GetAlertsButton({
  onClick,
  variant = 'toolbar',
  className = '',
  label,
}) {
  const ariaLabel =
    label && label.trim() !== ''
      ? label.trim()
      : 'Watch this search';

  if (variant === 'text') {
    return (
      <button
        type="button"
        className={`get-alerts-btn get-alerts-btn--text${className ? ` ${className}` : ''}`}
        onClick={onClick}
        aria-label={ariaLabel}
      >
        <BellIconSmall />
        <span className="get-alerts-btn__text-label">Watch</span>
      </button>
    );
  }

  return (
    <button
      type="button"
      className={`get-alerts-btn get-alerts-btn--toolbar${className ? ` ${className}` : ''}`}
      onClick={onClick}
      aria-label={ariaLabel}
    >
      <BellIconSmall />
      <span className="get-alerts-btn__toolbar-label">Watch this search</span>
    </button>
  );
}
